import * as React from "react";
import * as i18n from "i18next";

import BusyOverlay from "components/busyOverlay";
import { Route, Switch } from "react-router";
import NotFound from "components/notFound";
import Navigation from "./pages/navigation";
import { MultiSelectItem } from "components/multiselect";
import { withTranslation, WithTranslation } from "react-i18next";
import httpService from "core/infrastructure/http";
import axios from "axios";

import * as Monitoring from "core/pages/system/monitoring";
import * as MonitoringFailed from "core/pages/system/monitoringFailed";
import * as MonitoringConfig from "core/pages/system/monitoringConfig";
import * as JaoLogin from "core/pages/system/jaoLogin";
import * as Home from "core/pages/system/home";
import * as Api from "core/pages/system/api";

import * as IbwtNtcAdjustment from "core/pages/ibwt/ntcAdjustment";
import * as IbwtAllocationConstraint from "core/pages/ibwt/allocationConstraint";
import * as IbwtIdAllocationConstraint from "core/pages/ibwt/idAllocationConstraint";
import * as IbwtCnecInfo from "core/pages/ibwt/cnecInfo";
import * as IbwtIdNtcAdjustment from "core/pages/ibwt/idNtcAdjustment";
import * as IbwtIdCnecInfo from "core/pages/ibwt/idCnecInfo";
import * as IbwtIdForecasted from "core/pages/ibwt/idForecasted";
import * as IbwtForecasted from "core/pages/ibwt/forecasted";
import * as IbwtFinalTtcNtc from "core/pages/ibwt/finalTtcNtc";
import * as IbwtIdFinalTtcNtc from "core/pages/ibwt/idFinalTtcNtc";
import * as IbwtStaticGridModelLines from "core/pages/ibwt/staticGridModelLines";
import * as IbwtStaticGridModelTransformers from "core/pages/ibwt/staticGridModelTransformers";
import * as IbwtValidationId from "core/pages/ibwt/validationId";
import * as IbwtValidationDa from "core/pages/ibwt/validationDa";

import * as Ida1ScheduledExchanges from "core/pages/ibwt/scheduledExchanges/ID1";
import * as Ida1PriceSpread from "core/pages/ibwt/priceSpread/ID1";
import * as Ida1CongestionIncome from "core/pages/ibwt/congestionIncome/ID1";

import * as Ida2ScheduledExchanges from "core/pages/ibwt/scheduledExchanges/ID2";
import * as Ida2PriceSpread from "core/pages/ibwt/priceSpread/ID2";
import * as Ida2CongestionIncome from "core/pages/ibwt/congestionIncome/ID2";

import * as Ida3ScheduledExchanges from "core/pages/ibwt/scheduledExchanges/ID3";
import * as Ida3PriceSpread from "core/pages/ibwt/priceSpread/ID3";
import * as Ida3CongestionIncome from "core/pages/ibwt/congestionIncome/ID3";


export interface ApplicationState {
    applicationRoot: string;
    apiService: string;
    environment: string;
    userMail: string;
    userRole: string;
    userToken: string;
    guestToken: string;
    changeToken(usermail: string, role: string, newToken: string): void;
    selectedDate: Date;
    getYearUtcTime(): Date;
    getRootUtcTime(): Date;
    getUntilFor1Day(): Date;
    getUntilFor1Hour(): Date;
    getUntilFor1Year(): Date;
    setCweTimeForDate(d: Date, h: number, m: number): Date,
    getCweTimeForDisplayPurposes(d: Date): Date,
    convertCweHourToUtcDate(d: Date): Date;
    handleDateChange(d: Date): void;
    selectedBorders: MultiSelectItem[];
    handleBorderChange(selectedBorder: MultiSelectItem, special: string): void;
    handleHubChange(selectedHub: MultiSelectItem, special: string): void;
    handleHorizonChange(horizon: string): void;
    selectedHubs: MultiSelectItem[];
    selectedTsos: MultiSelectItem[];
    hubToHubExchange: { [key: string]: { text: string, value: number } };
    hubExchange: { [key: string]: { text: string, value: number } };
    addHubToHubExchange(borders: MultiSelectItem[]): void;
    handleHubToHubExchangeChange(id: string, value: string, ptdfHubs: string[]): void;
    hubToHubPosition: { [key: string]: { text: string, value: number } };
    addHubToHubPosition(hubs: MultiSelectItem[]): void;
    handleHubToHubPositionChange(id: string, value: string): void;
    dateSteps: string;
    horizon: string;
    isBorderEnabled: boolean;
    isHubEnabled: boolean;
    handleInputAvailablilityChange: (dateSteps: string, borderEnabled: boolean, hubEnabled: boolean, availableColumns: string[]) => void;
    pages: Page[];
    initialized: boolean;
    maxRows: number;
    pageSize: number;
}
interface Page {
    config: any;
    component: any;
}
interface Props {
    apiService: string;
    bearerToken: string;
    applicationRoot: string;
    username: string;
    role: string;
    environment: string;
}

class App extends React.Component<Props & WithTranslation, ApplicationState> {

    constructor(props: Props & WithTranslation) {
        super(props);

        const GetYearUtcTime = () => {
            return setCweTime(new Date(this.state.selectedDate.getFullYear(), 0, 1), 0, 0);
        }
        const GetRootUtcTime = () => {
            return setCweTime(getCweTimeForDisplayPurposes(this.state.selectedDate), 0, 0);
        }
        const GetUntilFor1Day = () => {
            const nextDay = new Date(new Date(this.state.selectedDate).setDate(this.state.selectedDate.getDate() + 1));
            return setCweTime(getCweTimeForDisplayPurposes(nextDay), 0, 0);
        }
        const GetUntilFor1Hour = () => {
            return new Date(new Date(this.state.selectedDate).setUTCHours(this.state.selectedDate.getUTCHours() + 1));
        }
        const GetUntilFor1Year = () => {
            return setCweTime(new Date(this.state.selectedDate.getFullYear(), 11, 31), 23, 0);;
        }

        const setCweTime = (date: Date, hour: number, minute: number) => {
            const hourLocalTime = new Date(new Date(date).setHours(hour, minute, 0, 0));
            return convertCweHourToUtcDate(hourLocalTime);
        }
        const convertCweHourToUtcDate = (localDate: Date) => {
            //Input  = 2022-01-02 00:00:00 +0200 aka 2022-01-01 22:00:00 UTC
            //Means  = 2022-01-02 00:00:00 +0100 aka 2022-01-01 23:00:00 UTC
            //Output = 2022-01-02 01:00:00 +0200 aka 2022-01-01 23:00:00 UTC

            //const isDST = localDate.getTimezoneOffset() == new Date("2022-06-06").getTimezoneOffset();
            const oppositeCWETime = getCweTimeForDisplayPurposes(localDate);
            const diff = localDate.getTime() - oppositeCWETime.getTime();
            return new Date(new Date(localDate).setTime(localDate.getTime() + diff));
        }
        const getCweTimeForDisplayPurposes = (correctUtcDate: Date) => {
            //next use .getFullYear() .getMonth() .getDate() .getHours() .getMinutes() .getSeconds()

            //This logic is also in TDatetime.tsx
            return new Date(correctUtcDate.toLocaleString('en-US', { timeZone: 'Europe/Brussels' }));
        }

        const nextDay = new Date(new Date().setDate(new Date().getDate() + 1));
        const nextDayHourOneCWETime = setCweTime(nextDay, 0, 0);

        axios.interceptors.response.use(undefined, (error) => {
            const expectedError =
                error.response &&
                error.response.status >= 400 &&
                error.response.status < 500;

            if (!expectedError) {
                (async function runAsync() {
                    await httpService.logError(props.applicationRoot, "MAIN", error.response);
                })();
            }

            return Promise.reject(error);
        });

        this.state = {
            applicationRoot: props.applicationRoot,
            apiService: props.apiService,
            environment: props.environment,
            userMail: props.username,
            userRole: props.role,
            userToken: props.bearerToken,
            guestToken: props.bearerToken,
            changeToken: this.handleTokenChange,
            selectedDate: nextDayHourOneCWETime, //can be overwritten in componentDidMount
            getYearUtcTime: GetYearUtcTime,
            getRootUtcTime: GetRootUtcTime,
            getUntilFor1Day: GetUntilFor1Day,
            getUntilFor1Hour: GetUntilFor1Hour,
            getUntilFor1Year: GetUntilFor1Year,
            setCweTimeForDate: setCweTime,
            convertCweHourToUtcDate: convertCweHourToUtcDate,
            getCweTimeForDisplayPurposes: getCweTimeForDisplayPurposes,
            handleDateChange: this.handleDateChange,
            selectedBorders: [],
            handleBorderChange: this.handleBorderChange,
            handleHubChange: this.handleHubChange,
            handleHorizonChange: this.handleHorizonChange,
            selectedHubs: [],
            selectedTsos: [],
            hubToHubExchange: {},
            hubExchange: {},
            addHubToHubExchange: this.addHubToHubExchange,
            handleHubToHubExchangeChange: this.handleHubToHubExchangeChange,
            hubToHubPosition: {},
            addHubToHubPosition: this.addHubToHubPosition,
            handleHubToHubPositionChange: this.handleHubToHubPositionChange,
            dateSteps: "H",
            horizon: "",
            isBorderEnabled: true,
            isHubEnabled: true,
            initialized: false,
            maxRows: 100,
            pageSize: 1000,
            handleInputAvailablilityChange: this.handleInputAvailablilityChange,
            pages: [
                //HOME SHOULD BE FIRST ONE! (that is the default one)
                { config: Home.page_config, component: () => <Home.default applicationState={this.state} /> },
                { config: Monitoring.page_config, component: () => <Monitoring.default applicationState={this.state} /> },
                { config: MonitoringFailed.page_config, component: () => <MonitoringFailed.default applicationState={this.state} /> },
                { config: JaoLogin.page_config, component: () => <JaoLogin.default applicationState={this.state} /> },
                { config: MonitoringConfig.page_config, component: () => <MonitoringConfig.default applicationState={this.state} /> },
                { config: Api.page_config, component: () => <Api.default applicationState={this.state} /> },

                { config: IbwtCnecInfo.page_config, component: () => <IbwtCnecInfo.default applicationState={this.state} /> },
                { config: IbwtIdCnecInfo.page_config, component: () => <IbwtIdCnecInfo.default applicationState={this.state} /> },
                { config: IbwtForecasted.page_config, component: () => <IbwtForecasted.default applicationState={this.state} /> },
                { config: IbwtIdForecasted.page_config, component: () => <IbwtIdForecasted.default applicationState={this.state} /> },
                { config: IbwtNtcAdjustment.page_config, component: () => <IbwtNtcAdjustment.default applicationState={this.state} /> },
                { config: IbwtIdNtcAdjustment.page_config, component: () => <IbwtIdNtcAdjustment.default applicationState={this.state} /> },
                { config: IbwtFinalTtcNtc.page_config, component: () => <IbwtFinalTtcNtc.default applicationState={this.state} /> },
                { config: IbwtIdFinalTtcNtc.page_config, component: () => <IbwtIdFinalTtcNtc.default applicationState={this.state} /> },
                { config: IbwtAllocationConstraint.page_config, component: () => <IbwtAllocationConstraint.default applicationState={this.state} /> },
                { config: IbwtIdAllocationConstraint.page_config, component: () => <IbwtIdAllocationConstraint.default applicationState={this.state} /> },
                { config: IbwtStaticGridModelLines.page_config, component: () => <IbwtStaticGridModelLines.default applicationState={this.state} /> },
                { config: IbwtStaticGridModelTransformers.page_config, component: () => <IbwtStaticGridModelTransformers.default applicationState={this.state} /> },
                { config: IbwtValidationDa.page_config, component: () => <IbwtValidationDa.default applicationState={this.state} /> },
                { config: IbwtValidationId.page_config, component: () => <IbwtValidationId.default applicationState={this.state} /> },

                { config: Ida1ScheduledExchanges.page_config, component: () => <Ida1ScheduledExchanges.default applicationState={this.state} /> },
                { config: Ida1PriceSpread.page_config, component: () => <Ida1PriceSpread.default applicationState={this.state} /> },
                { config: Ida1CongestionIncome.page_config, component: () => <Ida1CongestionIncome.default applicationState={this.state} /> },

                { config: Ida2ScheduledExchanges.page_config, component: () => <Ida2ScheduledExchanges.default applicationState={this.state} /> },
                { config: Ida2PriceSpread.page_config, component: () => <Ida2PriceSpread.default applicationState={this.state} /> },
                { config: Ida2CongestionIncome.page_config, component: () => <Ida2CongestionIncome.default applicationState={this.state} /> },

                { config: Ida3ScheduledExchanges.page_config, component: () => <Ida3ScheduledExchanges.default applicationState={this.state} /> },
                { config: Ida3PriceSpread.page_config, component: () => <Ida3PriceSpread.default applicationState={this.state} /> },
                { config: Ida3CongestionIncome.page_config, component: () => <Ida3CongestionIncome.default applicationState={this.state} /> }
            ]
        };

    };

    getDateFromUrl = () => {
        const queryString = window.location.search;

        const cweDateString = /cwe=(\d{4})-(\d{2})-(\d{2})_(\d{2}):(\d{2})/i.exec(queryString);
        if (cweDateString != null) {
            const d = new Date(+cweDateString[1], +cweDateString[2] - 1, +cweDateString[3]);
            return this.state.setCweTimeForDate(d, +cweDateString[4], +cweDateString[5]);
        }

        const utcDateString = /utc=(\d{4})-(\d{2})-(\d{2})_(\d{2}):(\d{2})/i.exec(queryString);
        if (utcDateString != null) {
            const d = new Date(+utcDateString[1], +utcDateString[2] - 1, +utcDateString[3], 12, 0); //hour 12 to make sure it is in the next day
            return new Date(d.setUTCHours(+utcDateString[4]));
        }
        return null;
    };

    componentDidMount() {
        let pathName = window.location.pathname; // = pathname; -> but useLocation() fails
        pathName = pathName.startsWith("/") ? pathName.substring(1, pathName.length) : pathName;
        this.setState({ horizon: pathName.substring(0, 3) });

        const stateSavedOn = localStorage.getItem('lastSavedOn');
        if (stateSavedOn != null) {
            const diffInSeconds = (new Date().getTime() - new Date(stateSavedOn).getTime()) / 1000;
            if (diffInSeconds < 3600) { //onehour
                const savedSelectedDate = localStorage.getItem('selectedDate');
                if (savedSelectedDate != null) {
                    this.setState({ selectedDate: new Date(savedSelectedDate) });
                }

                const savedSelectedBorders = localStorage.getItem('selectedBorders');
                if (savedSelectedBorders != null) {
                    const savedBorders: any = JSON.parse(savedSelectedBorders);
                    this.setState({ selectedBorders: savedBorders });
                }

                const savedSelectedHubs = localStorage.getItem('selectedHubs');
                if (savedSelectedHubs != null) {
                    const savedHubs: any = JSON.parse(savedSelectedHubs);
                    this.setState({ selectedHubs: savedHubs });
                }
            }
        }

        const dateInUrl = this.getDateFromUrl();
        if (dateInUrl != null) {
            this.setState({ selectedDate: new Date(dateInUrl) });
            history.pushState("", "", window.location.href.replace(location.search, ""));
        }

        i18n.default.loadNamespaces(
            ["common", "common_tsos", "common_borders", "common_hubs", "swe_common"],
            () => { // LOAD COMMON TRANSLATION FILES

                const allBorderTranslations = i18n.default.getResourceBundle("en", "common_borders");
                this.setState({
                    selectedBorders: Object.keys(allBorderTranslations)
                        .filter((value, index, self) => self.indexOf(value) === index) // =distinct
                        .map((k) => {
                            return {
                                id: k,
                                text: allBorderTranslations[k],
                                selected: true,
                                isDisplayed: true
                            };
                        }).sort((a, b) => a.id.localeCompare(b.id))
                });

                const allHubTranslations = i18n.default.getResourceBundle("en", "common_hubs");
                this.setState({
                    selectedHubs: Object.keys(allHubTranslations).map((k) => {
                        return {
                            id: k,
                            text: allHubTranslations[k],
                            selected: true,
                            isDisplayed: true
                        };
                    }).sort((a, b) => a.id.localeCompare(b.id))
                });

                const allTsoTranslations = i18n.default.getResourceBundle("en", "common_tsos");
                this.setState({
                    selectedTsos: Object.keys(allTsoTranslations).map((k) => {
                        return {
                            id: k,
                            text: allTsoTranslations[k],
                            selected: true,
                            isDisplayed: true
                        };
                    })
                });

                this.setState({
                    initialized: true
                });
            });
    }

    handleTokenChange = (userMail: string, userRole: string, userToken: string) => {
        this.setState({ userMail, userRole, userToken });
    }

    handleDateChange = (selectedDate: Date) => {
        this.setState({ selectedDate });
        localStorage.setItem('selectedDate', selectedDate.toISOString());
        localStorage.setItem('lastSavedOn', new Date().toISOString());
    }

    handleInputAvailablilityChange = (dateSteps: string, borderEnabled: boolean, hubEnabled: boolean, availableColumns: string[]) => {
        this.setState({
            dateSteps: dateSteps,
            isBorderEnabled: borderEnabled,
            isHubEnabled: hubEnabled,
            selectedBorders:
                [
                    ...this.state.selectedBorders,
                    ...availableColumns
                        .filter((value, index, self) => self.indexOf(value) === index) // =distinct
                        .filter(k => k.toLowerCase().startsWith("border_") && this.state.selectedBorders.filter(s => s.id.toLowerCase() === k.toLowerCase().replace("border_", "")).length === 0)
                        .map((key) => {
                            return {
                                isDisplayed: false,
                                id: key.toLowerCase().replace("border_", "").toUpperCase(),
                                text: key.toLowerCase().replace("border_", "").replace("_", "►").toUpperCase(),
                                selected: true
                            };
                        })
                ]
                    .map((item) => {
                        return { ...item, isDisplayed: availableColumns.length !== 0 && availableColumns.filter(f => f.toLowerCase() === item.id.toLowerCase() || f.toLowerCase() === "border_" + item.id.toLowerCase() || f.toLowerCase() === "initial_" + item.id.toLowerCase() || f.toLowerCase() === "bilateral_IDA1_" + item.id.toLowerCase()).length > 0 };
                    }).sort((a, b) => a.id.localeCompare(b.id)) // ascending
            ,
            selectedHubs:
                [
                    ...this.state.selectedHubs,
                    ...availableColumns
                        .filter((value, index, self) => self.indexOf(value) === index) // =distinct
                        .filter(k => k.toLowerCase().startsWith("hub_") && this.state.selectedHubs.filter(s => s.id.toLowerCase() === k.toLowerCase().replace("hub_", "")).length === 0)
                        .map((key) => {
                            return {
                                isDisplayed: false,
                                id: key.toLowerCase().replace("hub_", "").toUpperCase(),
                                text: key.toLowerCase().replace("hub_", "").toUpperCase(),
                                selected: true
                            };
                        })
                ]
                    .map((item) => {
                        return { ...item, isDisplayed: availableColumns.length !== 0 && availableColumns.filter(f => f.toLowerCase() === "hub_" + item.id.toLowerCase() || f.toLowerCase() === "min" + item.id.toLowerCase() || f.toLowerCase() === "generation_" + item.id.toLowerCase()).length > 0 };
                    }).sort((a, b) => a.id.localeCompare(b.id)) // ascending
            ,
            selectedTsos:
                [
                    ...this.state.selectedTsos,
                    ...availableColumns
                        .filter((value, index, self) => self.indexOf(value) === index) // =distinct
                        .filter(k => k.toLowerCase().startsWith("tso_") && this.state.selectedTsos.filter(s => s.id.toLowerCase() === k.toLowerCase().replace("tso_", "")).length === 0)
                        .map((key) => {
                            return {
                                isDisplayed: false,
                                id: key.replace("tso_", ""),
                                text: key.replace("tso_", ""),
                                selected: true
                            };
                        })
                ]
                    .map((item) => {
                        return { ...item, isDisplayed: availableColumns.length !== 0 && availableColumns.filter(f => f.toLowerCase() === "tso_" + item.id.toLowerCase()).length > 0 };
                    }).sort((a, b) => a.id.localeCompare(b.id)) // ascending

        });
    }

    handleBorderChange = (selectedBorder: MultiSelectItem, special: string) => {
        const newList = this.state.selectedBorders.map((item) => {
            if (special === "ALL") {
                return { ...item, selected: true };
            }
            if (special === "NONE") {
                return { ...item, selected: false };
            }
            if (item.id === selectedBorder.id) {
                return { ...item, selected: !item.selected };
            }
            return item;
        });
        this.setState({ selectedBorders: newList });
        localStorage.setItem('selectedBorders', JSON.stringify(newList));
        localStorage.setItem('lastSavedOn', new Date().toISOString());
    }

    handleHubChange = (selectedHub: MultiSelectItem, special: string) => {
        const newList = this.state.selectedHubs.map((item) => {
            if (special === "ALL") {
                return { ...item, selected: true };
            }
            if (special === "NONE") {
                return { ...item, selected: false };
            }
            if (item.id === selectedHub.id) {
                return { ...item, selected: !item.selected };
            }
            return item;
        });
        this.setState({ selectedHubs: newList });
        localStorage.setItem('selectedHubs', JSON.stringify(newList));
        localStorage.setItem('lastSavedOn', new Date().toISOString());
    }

    handleHorizonChange = (horizon: string) => {
        this.setState({ horizon: horizon });
    }

    addHubToHubExchange = (borders: MultiSelectItem[]) => {
        this.setState({
            hubToHubExchange: Object.assign({}, ...borders.map((border) => ({ [border.id]: { text: "0", value: 0 } }))),
        });
    }
    addHubToHubPosition = (hubs: MultiSelectItem[]) => {
        this.setState({
            hubToHubPosition: Object.assign({}, ...hubs.map((hub) => ({ [hub.id]: { text: "0", value: 0 } }))),
        });
    }
    handleHubToHubExchangeChange = (id: string, value: string, ptdfHubs: string[]) => {
        const copy = { ...this.state.hubToHubExchange };
        copy[id] = { text: value, value: parseFloat(value) };
        this.setState({ hubToHubExchange: copy });
    }
    handleHubToHubPositionChange = (id: string, value: string) => {
        const copy = { ...this.state.hubToHubPosition };
        copy[id] = { text: value, value: parseFloat(value) };
        this.setState({ hubToHubPosition: copy });
    }

    render() {
        return (
            <div style={{ display: "grid", gridTemplateColumns: "225px auto", height: "100%" }}>
                {!this.state.initialized
                    ? <div></div>
                    : <Navigation applicationState={this.state} />
                }
                <div style={{ overflow: "auto", display: "flex", flexDirection: "column" }}>
                    <React.Suspense fallback={<BusyOverlay />}>
                        {!this.state.initialized
                            ? <div></div>
                            : <Switch>
                                {this.state.pages.map(p => <Route path={"/" + p.config.webUrl} exact={true} component={p.component} />)}
                                <Route path="/" exact={true} component={this.state.pages[0].component} />
                                <Route component={NotFound} />
                            </Switch>
                        }
                    </React.Suspense>
                </div>
            </div>
        );
    }
}

export default withTranslation()(App);
